<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<div v-if="infoData" class="block_1">
				<img
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					class="bg"
					:src="webUrl + infoData.thumb"
				/>
				<div
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
					class="cate_box"
				>
					<div v-for="(value, index) in infoData.cate_list" :key="value.id" class="cate_el">{{ value.title }}</div>
					<div v-for="(value, index) in infoData.scenarios_list" :key="value.id" class="cate_el">{{ value.title }}</div>
				</div>
				<div
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
					class="tit"
				>{{ infoData.name }}</div>
				<div
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
					class="desc"
				>{{ infoData.description }}</div>
				<div
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
					v-html="infoData.content"
					class="content_box"
				></div>
			</div>
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { UPURL } from '@/util/util';
import { productInfo, productCount } from '@/api/public'
import md5 from 'js-md5';
import moment from 'moment';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			webUrl: UPURL
		}
	},
	created(){
		let that = this;
		//请求产品详情
		if(that.$route.params.productInfoId) {
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productInfo({ id: that.$route.params.productInfoId.split('.')[0] }).then(res => {
				that.infoData = res.data;
				document.title = that.infoData.name;
				that.$toast.clear();
				//访问统计
				let time = String(moment().unix());
				setTimeout(() => {
					productCount({
						language: sessionStorage.getItem('lang'),
						productid: that.infoData.id,
						cate_id: that.infoData.cate_id,
						scenarios_id: that.infoData.scenarios_id ? that.infoData.scenarios_id : '',
						url: that.$route.name,
						addtime: time,
						sign: md5(String(that.infoData.cate_id) + String(that.infoData.scenarios_id ? that.infoData.scenarios_id : '') + String(that.infoData.id) + that.$route.name + String(time) + 'Abiores2024'),
					}).then(res => {});
				}, 10000);
			});
		}else {
			that.$toast('Error');
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	.block_1{
		padding: 40px 16px;
		.content_box{
			word-break: break-all;
		}
		.desc{
			padding-bottom: 20px;
			font-size: 16px;
		}
		.tit{
			padding-bottom: 10px;
			font-size: 20px;
			font-weight: bold;
		}
		.cate_box{
			padding: 40px 0 10px 0;
			.cate_el{
				display: inline-block;
				margin: 0 8px 8px 0;
				padding: 4px 6px;
				color: #666666;
				border: 1px solid #EEEEEE;
				border-radius: 8px;
				font-size: 12px;
				background-color: #F9F8F6;
			}
		}
		.bg{
			width: 100%;
			box-shadow: 0px 0px 30px 1px rgba(0,0,0,0.16);
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .content_box img{
	max-width: 100%;
	height: auto;
}
>>> .main_box .content_box td, >>> .main_box .content_box th {
	padding: 5px;
	border: 1px solid #ddd;
}
>>> .main_box .content_box table{
	width: 100%;
	border-collapse: collapse;
}
.content_box{
	overflow: auto;
}
</style>